// extracted by mini-css-extract-plugin
export var moreProduct = "y_dZ";
export var title = "y_bq";
export var productList = "y_cR";
export var productItem = "y_d0";
export var img = "y_bz";
export var label = "y_b8";
export var country = "y_d1";
export var marks = "y_d2";
export var labels = "y_d3";